import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

export interface TaxonomyOption {
  value: string;
  label_nl: string;
  label_en: string;
}

export interface ProfileTaxonomy {
  specialisatie_tags: TaxonomyOption[];
  doelgroep_niveaus: TaxonomyOption[];
  branche_affiniteiten: TaxonomyOption[];
  talen: TaxonomyOption[];
  max_specialisatie_tags: number;
  max_bio_woorden: number;
  min_tijdslots: number;
}

/**
 * Taxonomie voor het profielformulier (specialismen, doelgroepen, branches,
 * talen). Komt van de backend zodat formulier en HR-zoekmachine dezelfde
 * waarden gebruiken; de lijst verandert zelden, dus lang gecachet.
 */
export function useProfileTaxonomy() {
  return useQuery<ProfileTaxonomy>({
    queryKey: ['profile-taxonomy'],
    queryFn: async () => {
      const response = await api.get('/professional/taxonomy');
      return response.data.data;
    },
    staleTime: 60 * 60 * 1000,
  });
}

/** Label in de actieve taal; valt terug op de Nederlandse variant */
export function useTaxonomyLabel() {
  const { i18n } = useTranslation();
  return (option: TaxonomyOption) =>
    i18n.language?.startsWith('en') ? option.label_en : option.label_nl;
}
